import { getIsQuizOpen } from '@bridebook/web/lib/quiz/selectors';
import { useSelector } from '@bridebook/web/lib/utils';
import { lazyComponent } from '@bridebook/web/lib/utils/lazy/lazy-component';

const PhotoQuizLazy = lazyComponent(() => import('./photo-quiz'));

const PhotoQuiz = () => {
  const isQuizOpen = useSelector(getIsQuizOpen('photographyStyle'));

  if (!isQuizOpen) {
    return null;
  }

  return <PhotoQuizLazy />;
};

export default PhotoQuiz;
